import { type FC, type ReactNode } from "react";

import { column, comparisonText, container, row, wrap } from "./MetricChange.module.css";

interface MetricChangeProps {
    badge: ReactNode;
    text?: ReactNode;
    layout?: "row" | "column";
    wrapText?: boolean;
}

export const MetricChange: FC<MetricChangeProps> = ({ badge, text, layout = "row", wrapText = false }) => (
    <div className={`${container} ${layout === "column" ? column : row} ${wrapText ? wrap : ""}`}>
        {badge}
        {text ? <span className={comparisonText}>{text}</span> : null}
    </div>
);
